import { render } from "./UserSelection.vue?vue&type=template&id=0413d502&scoped=true&ts=true"
import script from "./UserSelection.vue?vue&type=script&lang=ts"
export * from "./UserSelection.vue?vue&type=script&lang=ts"

import "./UserSelection.vue?vue&type=style&index=0&id=0413d502&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0413d502"]])

export default __exports__